<template>
  <div class="newPassword">
    <v-container fill-height class="primary loginMain">
      <v-layout row wrap>
        <v-flex class="text-xs-center" xs12 sm12 md12 lg4 style="margin:auto">
          <div class="Formcard grey lighten-5 no-shadow card-r">
            <v-form row class="w-100">
              <v-flex xs12 md12 pt-0>
                <!--<v-flex xs12 md12 pt-0 pb-5>-->
                <!-- <h1 class="headline font-weight-medium">Create new password</h1> -->

                <v-toolbar flat xs12 class="transparent pa-0">
                  <div  class="btn-tool text-xs-right">
                    <router-link :to="`/resetPasswordVerification`" class="aBtn"><v-icon class="textColor">keyboard_backspace</v-icon></router-link>
                  </div>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>
                    <h2 class="textColor text-xs-center title">Create an Account</h2>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="hidden-sm-and-down">
                  </v-toolbar-items>
                </v-toolbar>
              </v-flex>
              <v-layout wrap class="logBD pt-130" >

                <v-flex xs12 sm12>
                  <!-- <p class="text-xs-left caption font-weight-regulars" >Enter a new password</p> -->
                  <v-text-field
                    solo
                    :type="passwordShow ? 'text' : 'password'"
                    :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                    @click:append="passwordShow = !passwordShow"
                    label="New Password"
                    v-model="password"
                    :rules="passwordRule"
                    required
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm12>
                  <v-text-field
                    outline
                    type="password"
                    label="Confirm Password"
                    v-model="confirmPassword"
                    :rules="ConfpasswordRule"
                    required
                    ></v-text-field>
                </v-flex> -->
                <v-flex xs12 sm12 pb-0 class="display-grid">
                  <v-btn class="h-50p text-white primary card-r no-shadow" color="white" :disabled="!loginAdmin" :to="`/login`">Confirm</v-btn>
                </v-flex>

              </v-layout>

            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: "NewPassword",
    data: () => ({
      newPassword: false,
      passwordShow:false,
      password: "",

      passwordRule: [
        v => !!v || "Password is required",
        v => v.length >= 8 || "Password must be more than 8 characters"
      ],
      ConfpasswordRule: [
        v => !!v || "Password is required",
        v => v == password || "Password is not match"
      ]
    })
  };
</script>
<style>
  .align{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/NewPassword.vue